import React, { forwardRef } from 'react';
import { styled } from '@compiled/react';
import Badge from '@atlaskit/badge';
import Button from '@atlaskit/button';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import { token } from '@atlaskit/tokens';

export interface PopupSelectTriggerProps {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	ref: any;
	'aria-haspopup': 'true';
	'aria-expanded': boolean;
	'aria-controls'?: string;
}

type FilterButtonProps = {
	label: string;
	isSelected: boolean;
	selectedCount: number;
	testId?: string;
} & PopupSelectTriggerProps;

export const FilterButton = forwardRef<HTMLElement, FilterButtonProps>(
	({ label, selectedCount, isSelected, testId, ...triggerProps }: FilterButtonProps, ref) => (
		<Button
			{...triggerProps}
			testId={testId}
			appearance="subtle"
			ref={ref ?? undefined}
			isSelected={isSelected}
			iconAfter={<ChevronDownIcon label="" />}
		>
			{label}
			{selectedCount > 0 && (
				<BadgeWrapper data-testid="software-code-page.common.ui.filter-button.badge">
					<Badge appearance="primary">{selectedCount}</Badge>
				</BadgeWrapper>
			)}
		</Button>
	),
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BadgeWrapper = styled.span({
	marginLeft: token('space.050', '4px'),
});
